module.exports = __webpack_public_path__ + "img/cryto.25f4934f.png";